import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import Button from '@atlaskit/button';
import ShortcutIcon from '@atlaskit/icon/glyph/shortcut';

import { FormFooter } from '@atlaskit/form';

import { messages } from '../messages';

export type SiteSelectorFormFooterProps = {
  readonly canSubmit: boolean;
  readonly onSwitchAccountClick: () => void;
  readonly onCancelClick: () => void;
  readonly fullScreenView?: boolean;
};

export function SiteSelectorFormFooter({
  canSubmit,
  onSwitchAccountClick,
  onCancelClick,
  fullScreenView
}: SiteSelectorFormFooterProps) {
  return (
    <FormFooter>
      <ActionsContainer>
        <LeftActionsContainer>
          <Button
            appearance="link"
            type="button"
            spacing="none"
            onClick={() => onSwitchAccountClick()}
          >
            <FormattedMessage {...messages.switchAccount} />
          </Button>
        </LeftActionsContainer>
        <RightActionsContainer>
          {fullScreenView !== true ? (
            <div>
              <Button
                appearance="subtle"
                type="button"
                onClick={() => onCancelClick()}
              >
                <FormattedMessage {...messages.cancel} />
              </Button>
              <PrimaryContainer>
                <Button
                  appearance="primary"
                  type="submit"
                  isDisabled={!canSubmit}
                  iconAfter={<ShortcutIcon label="" size="small" />}
                >
                  <FormattedMessage {...messages.createPage} />
                </Button>
              </PrimaryContainer>
            </div>
          ) : (
            <Button appearance="primary" type="submit" isDisabled={!canSubmit}>
              <FormattedMessage {...messages.createPage} />
            </Button>
          )}
        </RightActionsContainer>
      </ActionsContainer>
    </FormFooter>
  );
}

const ActionsContainer = styled.div`
  margin-top: 8px;
  position: relative;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
`;

const LeftActionsContainer = styled.div`
  flex-shrink: 0;
`;

const RightActionsContainer = styled.div`
  flex-shrink: 0;
  flex-grow: 1;
  text-align: right;
  & > :first-child {
    margin-right: 4px;
  }
`;

const PrimaryContainer = styled.span`
  margin-left: 4px;
`;
